import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { HomepageEventBanner } from '../models/homepage-event-banner.model';
import { ProfileService } from '../services/profile.service';

@Injectable({ providedIn: 'root' })
export class HomepageEventBannerResolver
  implements Resolve<HomepageEventBanner | null>
{
  private static readonly REQUEST_TIMEOUT_MS = 800;

  constructor(private profileService: ProfileService) {}

  resolve(): Observable<HomepageEventBanner | null> {
    return this.profileService.fetchHomepageEventBanner().pipe(
      timeout(HomepageEventBannerResolver.REQUEST_TIMEOUT_MS),
      map((response: any) =>
        response?.success === 0 ? response.data ?? null : null
      ),
      catchError(() => of(null))
    );
  }
}
